import { createSelector } from '@reduxjs/toolkit';
import { selectBenefitStatement } from '../../store/selectors';

export const selectBenefitStatementDetails = createSelector(selectBenefitStatement, (benefitStatement) => benefitStatement.details);
